// import PropTypes from "prop-types"
// import React, { useState, useEffect } from "react"
// import {
//   Row,
//   Col,
//   CardBody,
//   Card,
//   Alert,
//   Container,
//   Form,
//   Input,
//   FormFeedback,
//   Label,
// } from "reactstrap"
// import { useSelector, useDispatch } from "react-redux"
// import { withRouter, Link } from "react-router-dom"
// import * as Yup from "yup"
// import { useFormik } from "formik"
// import { loginUser } from "../../store/actions"
// import profile from "assets/images/profile-img.png"
// import logo from "assets/images/favicon.png"
// // import { getMessaging, getToken } from "firebase/messaging"
// // import { initializeApp } from "firebase/app"

// // const firebaseConfig = {
// //   apiKey: "AIzaSyBBFSouRX1vLUQvgH18DNDI0d2MJyRX_ws",
// //   authDomain: "bizzmate-a342c.firebaseapp.com",
// //   projectId: "bizzmate-a342c",
// //   storageBucket: "bizzmate-a342c.firebasestorage.app",
// //   messagingSenderId: "74542198545",
// //   appId: "1:74542198545:web:83548126f78d4f3f9ae6b0",
// //   measurementId: "G-BRYGRD5M6W",
// // }

// // // Initialize Firebase
// // const app = initializeApp(firebaseConfig)
// // const messaging = getMessaging(app)

// const Login = props => {
//   // useEffect(() => {
//   //   const fetchToken = async () => {
//   //     try {
//   //       const currentToken = await getToken(messaging, {
//   //         vapidKey:
//   //           "BPOscnut6Z3oJoamqfw_kx83F0YtDKrpxwOQCG1Hl1PkXPmh_HgaxWlVJAiVoa94lYM9M8SvfRWb_xhPKrztLF8",
//   //       })
//   //       if (currentToken) {
//   //         localStorage.setItem("fcmToken", currentToken)
//   //       } else {
//   //         console.log(
//   //           "No registration token available. Request permission to generate one."
//   //         )
//   //       }
//   //     } catch (err) {
//   //       console.log("An error occurred while retrieving token. ", err)
//   //     }
//   //   }
//   //   fetchToken()
//   // }, [])

//   const dispatch = useDispatch()

//   const validation = useFormik({
//     enableReinitialize: true,

//     initialValues: {
//       phone: "" || "",
//       password: "" || "",
//     },
//     validationSchema: Yup.object({
//       phone: Yup.string()
//         .required("Please Enter Your Phone")
//         .matches(/^[0-9]{10}$/, "Phone number must be exactly 10 digits"),
//       password: Yup.string().required("Please Enter Your Password"),
//     }),
//     onSubmit: values => {
//       dispatch(loginUser(values, props.history))
//     },
//   })

//   const { error } = useSelector(state => ({
//     error: state.Login.error.message,
//   }))

//   const togglePassword = () => {
//     if (passwordType === "password") {
//       setPasswordType("text")
//       return
//     }
//     setPasswordType("password")
//   }

//   const [passwordType, setPasswordType] = useState("password")

//   return (
//     <React.Fragment>
//       <div className="home-btn d-none d-sm-block">
//         <Link to="/" className="text-dark">
//           <i className="fas fa-home h2" />
//         </Link>
//       </div>
//       <div className="account-pages my-5 pt-sm-5">
//         <Container>
//           <Row className="justify-content-center">
//             <Col md={8} lg={6} xl={5}>
//               <Card className="overflow-hidden">
//                 <div className="bg-primary bg-soft">
//                   <Row>
//                     <Col xs={7}>
//                       <div className="text-primary p-4">
//                         <h5 className="text-primary">
//                           Welcome To Bizzmate Supplier
//                         </h5>
//                       </div>
//                     </Col>
//                     <Col className="col-5 align-self-end">
//                       <img src={profile} alt="" className="img-fluid" />
//                     </Col>
//                   </Row>
//                 </div>
//                 <CardBody className="pt-0">
//                   <div>
//                     <Link to="/" className="auth-logo-light">
//                       <div className="avatar-md profile-user-wid mb-4">
//                         <span className="avatar-title rounded-circle bg-light">
//                           <img
//                             src={logo}
//                             alt=""
//                             className="rounded-circle"
//                             height="34"
//                           />
//                         </span>
//                       </div>
//                     </Link>
//                   </div>
//                   <div className="p-2">
//                     <Form
//                       className="form-horizontal"
//                       onSubmit={e => {
//                         e.preventDefault()
//                         validation.handleSubmit()
//                         return false
//                       }}
//                     >
//                       {error ? (
//                         <Alert color="danger">
//                           {"Please provide a valid phone or password"}
//                         </Alert>
//                       ) : null}

//                       <div className="mb-3">
//                         <Label className="form-label">Phone</Label>
//                         <Input
//                           name="phone"
//                           className="form-control"
//                           placeholder="Enter phone number (10 digits)"
//                           type="text"
//                           onChange={validation.handleChange}
//                           onBlur={validation.handleBlur}
//                           value={validation.values.phone || ""}
//                           invalid={
//                             validation.touched.phone && validation.errors.phone
//                               ? true
//                               : false
//                           }
//                           onKeyPress={e => {
//                             const charCode = e.which ? e.which : e.keyCode
//                             if (charCode < 48 || charCode > 57) {
//                               e.preventDefault()
//                             }
//                           }}
//                           maxlength="10"
//                           minLength="10"
//                           pattern="[0-9]{10}"
//                         />
//                         {validation.touched.phone && validation.errors.phone ? (
//                           <FormFeedback type="invalid">
//                             {validation.errors.phone}
//                           </FormFeedback>
//                         ) : null}
//                       </div>

//                       <div className="mb-3">
//                         <Label className="form-label">Password</Label>
//                         <div className="mb-3 input-group">
//                           <Input
//                             name="password"
//                             value={validation.values.password || ""}
//                             placeholder="Enter Password"
//                             onChange={validation.handleChange}
//                             onBlur={validation.handleBlur}
//                             invalid={
//                               validation.touched.password &&
//                               validation.errors.password
//                                 ? true
//                                 : false
//                             }
//                             type={passwordType}
//                           />
//                           <div className="input-group-btn">
//                             <button
//                               type="button"
//                               className="btn btn-outline-light"
//                               onClick={() => {
//                                 togglePassword()
//                               }}
//                               style={{ boxShadow: "none" }}
//                             >
//                               {passwordType === "password" ? (
//                                 <i
//                                   className="fa fa-eye-slash"
//                                   aria-hidden="true"
//                                 />
//                               ) : (
//                                 <i className="fa fa-eye" aria-hidden="true" />
//                               )}
//                             </button>
//                           </div>
//                           {validation.touched.password &&
//                           validation.errors.password ? (
//                             <FormFeedback type="invalid">
//                               {validation.errors.password}
//                             </FormFeedback>
//                           ) : null}
//                         </div>
//                       </div>

//                       <div className="mt-4 d-grid">
//                         <button
//                           className="btn btn-primary btn-block"
//                           type="submit"
//                         >
//                           Log In
//                         </button>
//                       </div>

//                       <div className="mt-4 text-center"></div>
//                       <div className="mt-4 text-center">
//                         <Link to="/forgot-password" className="text-muted">
//                           <i className="mdi mdi-lock me-1" />
//                           Forgot your password?
//                         </Link>
//                       </div>
//                     </Form>
//                   </div>
//                 </CardBody>
//               </Card>
//               <div className="mt-5 text-center">
//                 <p>
//                   Don&#39;t have an account ?{" "}
//                   <Link to="/register" className="fw-medium text-primary">
//                     {" "}
//                     Signup now{" "}
//                   </Link>{" "}
//                 </p>
//                 <p>
//                   © {new Date().getFullYear()} Bizzmate. Crafted with{" "}
//                   <i className="mdi mdi-heart text-danger" /> by Bizzmate
//                 </p>
//               </div>
//             </Col>
//           </Row>
//         </Container>
//       </div>
//     </React.Fragment>
//   )
// }

// export default withRouter(Login)

// Login.propTypes = {
//   history: PropTypes.object,
// }


import PropTypes from "prop-types"
import React, { useState, useEffect } from "react"
import {
  Row,
  Col,
  CardBody,
  Card,
  Alert,
  Container,
  Form,
  Input,
  FormFeedback,
  Label,
} from "reactstrap"
import { useSelector, useDispatch } from "react-redux"
import { withRouter, Link } from "react-router-dom"
import * as Yup from "yup"
import { useFormik } from "formik"
import { loginUser } from "../../store/actions"
import profile from "assets/images/profile-img.png"
import logo from "assets/images/favicon.png"

const Login = props => {
  const dispatch = useDispatch()
  const [showError, setShowError] = useState(false)

  const { error, loading, isUserLoggedIn } = useSelector(state => ({
    error: state.Login.error?.message,
    loading: state.Login.loading,
    isUserLoggedIn: state.Login.isUserLoggedIn,
  }))

  useEffect(() => {
    if (isUserLoggedIn) {
      setShowError(false)
    }
  }, [isUserLoggedIn])

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      phone: "" || "",
      password: "" || "",
    },
    validationSchema: Yup.object({
      phone: Yup.string()
        .required("Please Enter Your Phone")
        .matches(/^[0-9]{10}$/, "Phone number must be exactly 10 digits"),
      password: Yup.string().required("Please Enter Your Password"),
    }),
    onSubmit: values => {
      setShowError(true)
      dispatch(loginUser(values, props.history))
    },
  })

  const togglePassword = () => {
    setPasswordType(prevType => (prevType === "password" ? "text" : "password"))
  }

  const [passwordType, setPasswordType] = useState("password")

  return (
    <React.Fragment>
      <div className="home-btn d-none d-sm-block">
        <Link to="/" className="text-dark">
          <i className="fas fa-home h2" />
        </Link>
      </div>
      <div className="account-pages my-5 pt-sm-5">
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card className="overflow-hidden">
                <div className="bg-primary bg-soft">
                  <Row>
                    <Col xs={7}>
                      <div className="text-primary p-4">
                        <h5 className="text-primary">
                          Welcome To Bizzmate Supplier
                        </h5>
                      </div>
                    </Col>
                    <Col className="col-5 align-self-end">
                      <img src={profile} alt="" className="img-fluid" />
                    </Col>
                  </Row>
                </div>
                <CardBody className="pt-0">
                  <div>
                    <Link to="/" className="auth-logo-light">
                      <div className="avatar-md profile-user-wid mb-4">
                        <span className="avatar-title rounded-circle bg-light">
                          <img
                            src={logo}
                            alt=""
                            className="rounded-circle"
                            height="34"
                          />
                        </span>
                      </div>
                    </Link>
                  </div>
                  <div className="p-2">
                    <Form
                      className="form-horizontal"
                      onSubmit={e => {
                        e.preventDefault()
                        validation.handleSubmit()
                        return false
                      }}
                    >
                      {showError && error ? (
                        <Alert color="danger">
                          {"Please provide a valid phone or password"}
                        </Alert>
                      ) : null}

                      <div className="mb-3">
                        <Label className="form-label">Phone</Label>
                        <Input
                          name="phone"
                          className="form-control"
                          placeholder="Enter phone number (10 digits)"
                          type="text"
                          onChange={e => {
                            validation.handleChange(e)
                            setShowError(false)
                          }}
                          onBlur={validation.handleBlur}
                          value={validation.values.phone || ""}
                          invalid={
                            validation.touched.phone && validation.errors.phone
                              ? true
                              : false
                          }
                          onKeyPress={e => {
                            const charCode = e.which ? e.which : e.keyCode
                            if (charCode < 48 || charCode > 57) {
                              e.preventDefault()
                            }
                          }}
                          maxLength="10"
                          minLength="10"
                          pattern="[0-9]{10}"
                        />
                        {validation.touched.phone && validation.errors.phone ? (
                          <FormFeedback type="invalid">
                            {validation.errors.phone}
                          </FormFeedback>
                        ) : null}
                      </div>

                      <div className="mb-3">
                        <Label className="form-label">Password</Label>
                        <div className="mb-3 input-group">
                          <Input
                            name="password"
                            value={validation.values.password || ""}
                            placeholder="Enter Password"
                            onChange={e => {
                              validation.handleChange(e)
                              setShowError(false)
                            }}
                            onBlur={validation.handleBlur}
                            invalid={
                              validation.touched.password &&
                              validation.errors.password
                                ? true
                                : false
                            }
                            type={passwordType}
                          />
                          <div className="input-group-btn">
                            <button
                              type="button"
                              className="btn btn-outline-light"
                              onClick={togglePassword}
                              style={{ boxShadow: "none" }}
                            >
                              {passwordType === "password" ? (
                                <i
                                  className="fa fa-eye-slash"
                                  aria-hidden="true"
                                />
                              ) : (
                                <i className="fa fa-eye" aria-hidden="true" />
                              )}
                            </button>
                          </div>
                          {validation.touched.password &&
                          validation.errors.password ? (
                            <FormFeedback type="invalid">
                              {validation.errors.password}
                            </FormFeedback>
                          ) : null}
                        </div>
                      </div>

                      <div className="mt-4 d-grid">
                        <button
                          className="btn btn-primary btn-block"
                          type="submit"
                          disabled={loading}
                        >
                          {loading ? "Logging in..." : "Log In"}
                        </button>
                      </div>

                      <div className="mt-4 text-center"></div>
                      <div className="mt-4 text-center">
                        <Link to="/forgot-password" className="text-muted">
                          <i className="mdi mdi-lock me-1" />
                          Forgot your password?
                        </Link>
                      </div>
                    </Form>
                  </div>
                </CardBody>
              </Card>
              <div className="mt-5 text-center">
                <p>
                  Don&#39;t have an account ?{" "}
                  <Link to="/register" className="fw-medium text-primary">
                    {" "}
                    Signup now{" "}
                  </Link>{" "}
                </p>
                <p>
                  © {new Date().getFullYear()} Bizzmate. Crafted with{" "}
                  <i className="mdi mdi-heart text-danger" /> by Bizzmate
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default withRouter(Login)

Login.propTypes = {
  history: PropTypes.object,
}